import axiosInstance from "./authentication/axiosInstance";
import axiosInstanceReport from "./authentication/axiosInstanceReport";
import axiosInstanceReportErrorFile from "./authentication/axiosInstanceReportErrorFile";

export const jobServices = {

  getClientsDataInJob: async () => {
    const response = await axiosInstance.get("/jobs/clients");
    return response.data;
  },

  getJobDataFromId: async (jobId) => {
    const response = await axiosInstance.get(`/jobs/${jobId}`);
    return response.data;
  },

  postJobData: async (newPost) => {
    const response = await axiosInstance.post("/jobs", newPost);
    return response.data;
  },

  deleteJobData: async (jobId) => {
    const response = await axiosInstance.delete(`/jobs/${jobId}`);
    return response.data;
  },

  updateJobData: async (formUpdate) => {
    const response = await axiosInstance.put("/jobs", formUpdate);
    return response.data;
  },

  updateJobStatus: async (newStatus) => {
    const response = await axiosInstance.post("/jobs/updateStatus", newStatus);
    return response.data;
  },

  getJobStatus: async () => {
    const response = await axiosInstance.get("/users/jobstatus");
    return response.data;
  },

  getJobPlanCategorys: async (jobType) => {
    const response = await axiosInstance.get("/jobs/jobPlanCategories", {
      params: { jobType }
    });
    return response.data;
  },

  getBookKeepingAndVATCheckList: async (jobType) => {
    const response = await axiosInstance.get("/jobs/checklist/" + jobType);
    return response.data;
  },

  getCurrentJobsForStatusUpdate: async (page, size, search, filter, isTableShow, sortField, sortDir) => {
    const params = new URLSearchParams({
      pageNo: page,
      size: size,
      search: search || '',
      filter: filter || '',
      isTableShow: isTableShow,
      sortField: sortField || 'updatedAt',
      sortDir: sortDir || 'desc'
    }).toString();

    const response = await axiosInstance.get(`/jobs/jobListForStatusUpdate?${params}`);
    return response.data;
  },

  getClientsForJobTrackScreen: async () => {
    const response = await axiosInstance.get("/jobs/currenUserClients");
    return response.data;
  },

  getJobsByClientId: async (clientId) => {
    const response = await axiosInstance.get(`/jobs/jobByClientId/${clientId}`);
    return response.data;
  },

  getClientsByUserIds: async (userIds) => {
    const response = await axiosInstance.get("/jobs/clientsByUserIds", {
      params: { userIds }
    });
    return response.data;
  },

  getAllJobsForStatusUpdate: async () => {
    const response = await axiosInstance.get("/jobs/jobsForStatusUpdate");
    return response.data;
  },

  getJobFullDetailsById: async (jobId) => {
    const response = await axiosInstance.get(`/jobs/jobFullDetails/${jobId}`);
    return response.data;
  },

  bulkJobFileUpload: async (file) => {
    const response = await axiosInstanceReportErrorFile.post("/jobs/bulkJobCreation", file);
    return response.data;
  },

  downloadBulkJobErrorFIle: async (fileName) => {
    const response = await axiosInstanceReport.post(`/jobs/error-file?fileName=${fileName}`);
    return response;
  },

  downloadBulkJobFormat: async () => {
    const response = await axiosInstanceReport.post('/jobs/downloadBulkJobFormat');
    return response;
  },

  bulkJobCompletedFileUpload: async (file) => {
    const response = await axiosInstanceReportErrorFile.post("/jobs/bulkJobCompleted", file);
    return response.data;
  },

  forceCompleteJobs: async (bulkData) => {
    const response = await axiosInstance.post("/jobs/forceCompleteJobs", bulkData);
    return response.data;
  },

  downloadBulkJobCompletedErrorFIle: async (fileName) => {
    const response = await axiosInstanceReport.post(`/jobs/completed-job-error-file?fileName=${fileName}`);
    return response;
  },

  downloadBulkJobCompletedFormat: async () => {
    const response = await axiosInstanceReport.post('/jobs/downloadBulkJobCompletedFormat');
    return response;
  }

};
